<h4>I Know The Napkin Drawings Seem Desperate But Maybe There's A Curator In This Applebees</h4>
<p>2017</p>
<p>An at-home installation on the monotony and identity loss that followed finishing art school and moving to a small town. 15 major museums were invited to the opening, none showed up.</p>
<app-project-gallery [galleryItems]="galleryItems"></app-project-gallery>
